import React, { createContext, useState, useEffect, useContext } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../services/firebase";
import { AuthContext } from "./AuthContext";

export const PlatformContext = createContext({
    isPlatformUser: false,
    platformRole: null,
    platformPermissions: {},
    platformUser: null,
    loading: true,
    canPlatform: () => false,
});

export const PlatformProvider = ({ children }) => {
    const { user } = useContext(AuthContext);
    const [platformUser, setPlatformUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!user?.uid) {
            setPlatformUser(null);
            setLoading(false);
            return;
        }

        const ref = doc(db, "users", user.uid);
        const unsubscribe = onSnapshot(ref, (snap) => {
            if (snap.exists()) {
                const data = snap.data();
                if (data.role === "super_admin") {
                    setPlatformUser(data);
                } else {
                    setPlatformUser(null);
                }
            } else {
                setPlatformUser(null);
            }
            setLoading(false);
        }, () => {
            setPlatformUser(null);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [user?.uid]);

    const canPlatform = (permissionKey) => {
        if (!platformUser) return false;
        if (platformUser.platformRole === "owner") return true;
        return platformUser.platformPermissions?.[permissionKey] === true;
    };

    const value = {
        isPlatformUser: !!platformUser,
        platformRole: platformUser?.platformRole || null,
        platformPermissions: platformUser?.platformPermissions || {},
        platformUser,
        loading,
        canPlatform,
    };

    return (
        <PlatformContext.Provider value={value}>
            {children}
        </PlatformContext.Provider>
    );
};

export const usePlatform = () => {
    const context = useContext(PlatformContext);
    if (context === undefined) {
        throw new Error("usePlatform deve ser usado dentro de um PlatformProvider");
    }
    return context;
};
